module.exports = __webpack_public_path__ + "static/media/kz-night.01abe71c.jpg";